/// <amd-module name="NetSuite.ImageTextOverlay.ImageTextOverlayCCT"/>
define("NetSuite.ImageTextOverlay.ImageTextOverlayCCT", ["require", "exports", "NetSuite.ImageTextOverlay.ImageTextOverlayCCT.View"], function (require, exports, ImageTextOverlayCCT_View_1) {
    "use strict";
    return {
        mountToApp: function (container) {
            this.registerCCT(container);
        },
        registerCCT: function (container) {
            container.getComponent('CMS').registerCustomContentType({
                id: 'cct_netsuite_imagetextoverlaycct',
                view: ImageTextOverlayCCT_View_1.ImageTextOverlayCCTView,
                options: {
                    container: container,
                },
            });
        },
    };
});
